import AOS from 'aos';

export function init() {
	AOS.init({
		offset: 200,
		duration: 600,
		easing: 'ease-out',
		delay: 100,
		once: true
	});
}


// WEBPACK FOOTER //
// ./scripts/components/RevealContent.js